import { mainAdminSplitApi } from 'redux/store/mainSplitApi'

export interface CountryOption {
  countryCode: string
  fullName: string
}

const countryApi = mainAdminSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchCountries: builder.query<CountryOption[], void>({
      query: () => '/countries',
      providesTags: ['Countries'],
      keepUnusedDataFor: 600
    })
  })
})

export const { useFetchCountriesQuery } = countryApi
